import React from "react";

import TabsPage from '../TabsPage';

import ContentBlock from "components/ContentBlock";
import ButtonIconSelect from "components/ButtonIconSelect";

import './index.less';
import './themes/default.less';

export default class Treatment extends TabsPage {

    constructor(props) {
        super(props);

        this.dotsItems = [
            { name: this.tr("client.editInspection"), onClick: null },
            { name: this.tr("client.createDiary"), onClick: null },
            { name: this.tr("client.editComment"), onClick: null },
        ];

        this.state = {
            ...this.state,
            currentDiar: false,
            currentItem: { id: false, items: false },
            absol: false,
            phrase: [],
            tags: [],
            medSection: []
        };

        this.elementRefs = {};
    }

    componentDidMount() {
        this.refresh();

        super.componentDidMount();
    }

    refresh() {
        this.getData();
    }

    dateToServ(date) {
        return date ? this._helper.date.toDateServerStr(date) : null;
    }

    getMedSection2(arr, src) {
        const req = (arr?.find(it => it.medSection?.name === src) || {}).value;
        return req;
    }

    getDiagnosis(f) {
        if (!f)
            return;

        const diagnosis = this._config.diagnosis;

        Object.keys(f).forEach(it => {
            if (f[it] && f[it].includes(",")) {
                const text = [];
                const arr = f[it].split(",");
                arr.forEach(item => {
                    const d = (diagnosis.find(diag => diag.id === +item) || {}).abb;
                    text.push(d);
                });
                f[it] = text.join(",");
            } else if (f[it]) {
                const d = (diagnosis.find(diag => diag.id === +f[it]) || {}).abb;
                f[it] = d;
            }
        });

        return f;
    }

    async printForm043(inspectionId) {
        const { profileNumber, birthday, sex, personalData, phoneNumber } = this.props.info;
        this._helper.showLoading();
        const medInspection = await this._request.medInspection.getMedInspection(inspectionId);
        this._helper.hideLoading();

        const arrIns = (medInspection?.data[0] || {}).medInspectionHasMedSection;

        const fio = this._helper.string.formatFullName(this.props.info);
        const complaints = this.getMedSection2(arrIns, "Жалобы");
        const diagnosis = this.getMedSection2(arrIns, "Диагноз");
        const diagforICD = this.getMedSection2(arrIns, "Диагноз по МКБ");
        const currentDisease = this.getMedSection2(arrIns, "Развитие настоящего заболевания");
        const anamnesis = this.getMedSection2(arrIns, "Анамнез жизни");
        const inspExternal = this.getMedSection2(arrIns, "Внешний осмотр");
        const bite = "Не выбран";
        const dentalFormula = this.getDiagnosis((medInspection?.data[0] || {}).dentalFormula);

        const printInfo = {
            inspection: medInspection?.data[0],
            profileNumber,
            fio,
            birthday,
            sex,
            address: personalData?.REG_ADDRESS,
            phoneNumber,
            job: personalData?.JOB_KIND,
            complaints,
            diagnosis,
            diagforICD,
            currentDisease,
            anamnesis,
            inspExternal,
            bite,
            dentalFormula
        };
        this._print.form43u(printInfo);

        /*this.printShow("Inspection ", {
            clientId: id + "",
            inspectionId: inspectionId + "",
            date: this._helper.date.toDateServerStr(date),
        });*/

    }

    printInspection(it, inspectionId) {
        this.printForm043(inspectionId);
        /*const { beginDate } = it;
        const { id: clientId } = this.props.info;

        this.printShow("Inspection", {
            clientId: clientId.toString(),
            date: this.dateToServ(beginDate),
            inspectionId: inspectionId.toString(),
        });*/

    }

    printDiary(id, info) {
        const { birthday, doctorId } = this.props.info;
        const { beginDate } = this.state.currentItem;

        const fio = this._helper.string.formatFullName(this.props.info);
        const doctor = this._helper.string.formatFullName(this.props.getDoctorById(doctorId));

        const printInfo = {
            fio,
            birthday,
            beginDate,
            doctor,
            teeths: this._helper.getTeethNames(info.medDiaryHasTeeth),
            medDiaryHasMedSection: info.medDiaryHasMedSection
        };
        this._print.diary(printInfo);
        //const { id: inspectionId, beginDate } = it;
        //const { id: clientId } = this.props.info;

        /*this.printShow("Med_diary", {
            diaryId: id + ""
        });*/

    }

    async getData() {
        this._helper.showLoading();
        const { currentItem } = this.state;

        const { id } = this.props.info;
        //const resp = await this._request.visits.getForClient(id, "-endDate", false, ["WI_CREATED", "WI_REPLACED", "WI_COMPLETED"]);
        const filterCanceled = true;
        const resp = await this._request.visits.getForPlanClient(id, filterCanceled);
        const items = resp?.data || [];

        if (items.length > 0) {
            const cindex = currentItem.id ? items.findIndex(it => it.id === currentItem.id) : "-1";
            const ci = {
                id: items[cindex !== "-1" ? cindex : 0].id,
                items: items[cindex !== "-1" ? cindex : 0].medDiaries,
                medInspections: items[cindex !== "-1" ? cindex : 0].medInspections,
                comment1: items[cindex !== "-1" ? cindex : 0].comment1,
                beginDate: items[cindex !== "-1" ? cindex : 0].beginDate,
            };

            const respPh = await this._request.phrase.getAll();
            const phrase = respPh?.data || [];

            const respMs = await this._request.medSection.getAll();
            const medSection = respMs?.data || [];

            const tags = [...new Set(phrase.flatMap(phras => phras.tags))].map((it, i) => ({ id: i, name: it }));
            this.setState({ items, currentItem: ci, phrase, tags, medSection });
        } else {
            this.setState({ items });
        }

        this._helper.hideLoading();
    }

    scrollMenu(index) {
        if (this.elementRefs[index]?.scrollIntoView)
            this.elementRefs[index].scrollIntoView({ behavior: 'smooth' });
    }

    async updateVisit(visitId, info) {
        await this._request.visits.update(visitId, info);
        this.refresh();
    }

    saveComment({ comment }) {
        const { currentItem } = this.state;
        if (currentItem.id)
            this.updateVisit(currentItem.id, { comment1: comment });
    }

    onTagClick(key, index, indScr, e) {
        if (index === this.state.currentItem.index)
            this._helper.stopEvent(e);

        this.changeState("currentItem", key, this.scrollMenu.bind(this, indScr));
    }

    onChangeCurrentItem(key) {
        this.changeState("currentItem", key);
    }

    getMedSection(data) {
        const medInspectionHasMedSection = data.medSection.map(it => {
            const row = {
                medSectionId: it.id,
                medSectionUid: it.uid,
                value: data.sections[it.id] ? data.sections[it.id].value : "",
                id: data.sections[it.id] ? data.sections[it.id].idValue : null,
                domainId: data.domainId
            };
            return row;
        });
        return medInspectionHasMedSection;
    }

    async addEditStageDiary(data) {
        const { currentItem } = this.state;

        const medDiaryHasTeeth = data.selectedTeeth;

        const info = {
            domainId: data.domainId ? data.domainId : this.props.clinicId,
            wiId: currentItem.id,
            medDiaryHasMedSections: this.getMedSection(data),
            medDiaryHasTeeth: medDiaryHasTeeth,
        };

        if (data.medDiarieId) {
            info.id = data.medDiarieId;
        }

        this._helper.showLoading();

        await this._request.medDiary.addUpdate(info);

        this._helper.hideLoading();

        this.refresh();
    }

    async addEditStageInsp(data) {
        const { currentItem } = this.state;

        const dentalFormula = Array(85).fill().map((_, i) => {
            return data.diagnosisTeeth[i + 1] ? data.diagnosisTeeth[i + 1].map(it => it?.id).join(",") : "";
        });

        const info = {
            domainId: data.domainId ? data.domainId : this.props.clinicId,
            occlusion: data.occlusion,
            clientId: data.id,
            dentalFormula: dentalFormula,
            wiId: currentItem?.id,
            medInspectionHasMedSection: this.getMedSection(data),
        };

        if (data.medInspectionId)
            info.id = data.medInspectionId;

        this._helper.showLoading();

        await this._request.medInspection.addUpdate(info);

        this._helper.hideLoading();

        this.refresh();
    }

    async deleteDiary(id) {
        this._helper.showLoading();

        await this._request.medDiary.delete(id);

        this._helper.hideLoading();

        this.refresh();
    }

    async deleteInspection(id) {
        this._helper.showLoading();

        await this._request.medInspection.delete(id);

        this._helper.hideLoading();

        this.refresh();
    }

    deleteDiaryConfirm(id) {
        const message = this.tr("client.sureDeletingDiary");
        this._helper.confirm({ title: "client.deletingDiary", message }, this.deleteDiary.bind(this, id));
    }

    deleteInspectionConfirm(id) {
        const message = this.tr("client.sureDeletingInspection");
        this._helper.confirm({ title: "client.deletingInspection", message }, this.deleteInspection.bind(this, id));
    }

    getTitleDiary(data) {
        if (data.length > 0)
            return this._helper.getTeethNames(data).join(", ");
        return this.tr("client.notChosen");
    }

    renderDiary(items) {
        return (
            <div className="content flex col gap16">
                {items?.filter(it => it.value).map((it, i) => this.renderRow(it.title, it.value, false, i))}
            </div>
        );
    }

    renderInspection(items) {
        return (
            <div className="content flex col gap16">
                {items.medInspectionHasMedSection?.filter(it => it.value).map((it, i) => this.renderRow(it.title, it.value, false, i))}
            </div>
        );
    }

    renderItem(it, key, index) {
        return (
            <div
                key={"it_" + key}
                className={`rowItem rad8 hand`}
                onClick={this.onTagClick.bind(this, key, index, it.index)}>
                {it.title}
            </div>
        );
    }

    renderRowsMenu(info, key) {
        const { beginDate, endDate, doctorId, id, medDiaries, medInspections, comment1, status } = info;
        const { currentItem } = this.state;

        const period = this._helper.date.toPeriodStr(beginDate, endDate);
        const doctor = this._helper.string.formatFullName(this.props.getDoctorById(doctorId), "short");
        const row1 = `${period}, ${doctor}`;

        const row2 = [];

        let ind = 0;
        medDiaries?.forEach(it => {
            ind++;
            row2.push({ title: it.medDiaryHasTeeth.length > 0 ? this._helper.getTeethNames(it.medDiaryHasTeeth).join(", ") : this.tr("client.notChosen"), index: ind });
        });

        medInspections?.forEach(_ => {
            ind++;
            row2.push({ title: this.tr("client.inspection"), index: ind });
        });

        if (comment1) {
            ind++;
            row2.push({ title: this.tr("client.comment"), index: ind });
        }

        return (
            <div
                key={key}
                className={`rowMenu flex between gap8 rad4 ${currentItem.id === id ? "active" : ""}`}
                onClick={this.changeState.bind(this, "currentItem", { id, items: medDiaries, medInspections, comment1, beginDate })}>
                <div className="details flex col gap8">
                    <div className={`datename text p1SemiBold ${status === "WI_CANCELED" ? "disabled" : ""}`}>{row1}</div>
                    <div className="menuRow2 flex wrap text p2SemiBold gap8">
                        {row2.map((it, j) => this.renderItem(it, j, key))}
                    </div>
                </div>
                <div className="actions flex col centerAll">
                    <ButtonIconSelect
                        name={"dots"}
                        type={"icon"}
                        items={this.dotsItems}
                    />
                </div>
            </div>
        );
    }

    onChangeNotes(info) {
        this.props.openDialog("changeNote", info, this.saveComment.bind(this));
    }

    renderRightColumn() {

        const { info, openRightPopup } = this.props;
        const { currentItem, phrase, tags, medSection } = this.state;
        const { id, items, medInspections, comment1 } = currentItem;

        if (id === false)
            return null;

        info.phrase = phrase;
        info.tags = tags;
        info.medSection = medSection;

        this.elementRefs = {};

        console.log("currentItem", currentItem);


        return (
            <>
                <ContentBlock
                    title="client.newDiary"
                    icon={{ name: "plus", onClick: openRightPopup.bind(this, "inspection", info, "diary", this.addEditStageDiary.bind(this)) }}
                    border="dashed"
                >
                </ContentBlock>
                {items?.map((it, j) => (
                    <ContentBlock
                        Ref={el => this.elementRefs[j + 1] = el}
                        key={j}
                        title={this.getTitleDiary(it.medDiaryHasTeeth)}
                        icons={[
                            { name: "edit", onClick: openRightPopup.bind(this, "inspection", { ...info, medDiarieId: it.id }, "diary", this.addEditStageDiary.bind(this)) },
                            {
                                translate: true,
                                items: [
                                    { name: "expenses.print", onClick: this.printDiary.bind(this, it.id, it) },
                                    { name: "client.delete", onClick: this.deleteDiaryConfirm.bind(this, it.id) },
                                ]
                            }
                        ]}
                    >
                        {this.renderDiary(it.medDiaryHasMedSection)}
                    </ContentBlock>
                ))}
                {medInspections?.map((it, j) => (
                    <ContentBlock
                        Ref={el => this.elementRefs[items.length + j + 1] = el}
                        key={j}
                        title="client.inspection"
                        icons={[
                            {
                                name: "edit",
                                onClick: openRightPopup.bind(this, "inspection", { ...info, medInspectionId: it.id }, "inspection", this.addEditStageInsp.bind(this))
                            },
                            {
                                translate: true,
                                items: [
                                    { name: "expenses.print", onClick: this.printInspection.bind(this, currentItem, it.id) },
                                    { name: "client.delete", onClick: this.deleteInspectionConfirm.bind(this, it.id) },
                                ]
                            }
                        ]}
                    >
                        {this.renderInspection(it)}
                    </ContentBlock>
                ))}
                <ContentBlock
                    title="client.inspection"
                    icon={{ name: "plus", onClick: openRightPopup.bind(this, "inspection", info, "inspection", this.addEditStageInsp.bind(this)) }}
                    border="dashed"
                >
                </ContentBlock>
                {comment1 ? (
                    <ContentBlock
                        Ref={el => this.elementRefs[items.length + medInspections.length + 1] = el}
                        title="client.comment"
                        icon={{ name: "edit", onClick: this.onChangeNotes.bind(this, { comment: comment1 }) }}
                    >
                        <div className="text p1">{comment1}</div>
                    </ContentBlock>
                ) : (
                    <ContentBlock
                        title="client.comment"
                        icon={{ name: "plus", onClick: this.onChangeNotes.bind(this, {}) }}
                        border="dashed"
                    >
                    </ContentBlock>
                )}
            </>
        );
    }

    renderContent() {
        const { items } = this.state;

        return (<div className="tabsPage flex flex1 minH0 pos rel">
            <div className="flex flex1 pos abs sideAll">
                <div className="leftColumn flex">
                    <div className="flex flex1">
                        <div className="leftMenu flex col gap8 scrolling">
                            {items && items.length > 0 && items?.map((it, i) => this.renderRowsMenu(it, i))}
                        </div>
                    </div>
                </div>
                <div className="rightColumn flex flex1 col gap16 scrolling">
                    {(items && items.length > 0) ? this.renderRightColumn() : items ? <div>{this.tr("client.noVisits")}</div> : <div>{this.tr("client.getData")}</div>}
                </div>
            </div>
        </div>);
    }
}
